/* eslint-disable function-paren-newline */
import { RouteConfig } from 'vue-router'

import isAuthenticatedGuard from '@/router/guards/isAuthenticated'

/**
 * COMPONENTS
 */

const BookingStatus = () =>
  import(
    /* webpackChunkName: "booking-status" */
    '@/views/bookingStatus/BookingStatus.vue'
  )

/**
 * ROUTES
 */

const statusRoutes: Array<RouteConfig> = [
  {
    path: '/buchungsstatus',
    name: 'booking-status',
    component: BookingStatus,
    redirect: '/buchungsstatus/uebersicht',
    children: [
      {
        path: '/buchungsstatus/uebersicht',
        name: 'Buchungsstatus - Übersicht',
        component: BookingStatus,
        beforeEnter: isAuthenticatedGuard,
        meta: {
          bookingStatusSubPage: 'uebersicht',
          layout: 'booking-status',
          gtm: 'booking status - uebersicht',
          translateKey: 'PAGETITLE_GERMAN_OVERVIEW_BOOKINGSTATUS',
        },
      },

      {
        path: '/buchungsstatus/unsere-alltagshelfer',
        name: 'Buchungsstatus - unsere Alltagshelfer',
        component: BookingStatus,
        beforeEnter: isAuthenticatedGuard,
        meta: {
          bookingStatusSubPage: 'unsereAlltagshelfer',
          layout: 'booking-status',
          gtm: 'booking status - unsere alltagshelfer',
          translateKey: 'PAGETITLE_GERMAN_CAREGIVER_BOOKINGSTATUS',
        },
      },

      {
        path: '/buchungsstatus/finanzierung',
        name: 'Buchungsstatus - Finanzierung',
        component: BookingStatus,
        beforeEnter: isAuthenticatedGuard,
        meta: {
          bookingStatusSubPage: 'finanzierung',
          layout: 'booking-status',
          gtm: 'booking status - finanzierung',
          translateKey: 'PAGETITLE_GERMAN_FINANCING_BOOKINGSTATUS',
        },
      },

      {
        path: '/buchungsstatus/faq',
        name: 'Buchungsstatus - FAQ',
        component: BookingStatus,
        beforeEnter: isAuthenticatedGuard,
        meta: {
          bookingStatusSubPage: 'faq',
          layout: 'booking-status',
          gtm: 'booking status - faq',
          translateKey: 'PAGETITLE_GERMAN_FAQ_BOOKINGSTATUS',
        },
      },
    ],
  },
]

export default statusRoutes
